<!-- Project: GSSC Pilot Front-end -->
<!-- Filename: SyncModal.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,      -->
<!-- propagated, or distributed without prior approval by ESA.                  -->
<template>
  <div class="sync-modal modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Sync</h5>
          <button
            type="button"
            class="sync-modal__close close"
            data-dismiss="modal"
            aria-label="Close"
            @click="$emit('closeModal')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <!-- An option to have + and - buttons -->
            <!-- <div class="input-group">
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn btn-default btn-number"
                  disabled="disabled"
                  data-type="minus"
                  data-field="quant[1]"
                >
                  <span class="glyphicon glyphicon-minus"></span>
                </button>
              </span>
              <input type="text" name="quant[1]" class="form-control input-number" value="8" min="8" max="30" />
              <span class="input-group-btn">
                <button type="button" class="btn btn-default btn-number" data-type="plus" data-field="quant[1]">
                  <span class="glyphicon glyphicon-plus"></span>
                </button>
              </span>
            </div> -->
            <div class="form-group">
              <label for="name">Assets limit</label>
              <input
                ref="firstInputRef"
                v-model="limit"
                type="text"
                class="edit-lab-modal__name form-control"
                id="name"
                maxlength="40"
              />
            </div>
            <!-- <div class="form-group">
              <label for="description">Description</label>
              <textarea
                v-model="desc"
                type="text"
                class="edit-lab-modal__desc form-control"
                id="description"
                disabled
              />
            </div> -->
            <button
              class="sync-modal__cancel btn btn-primary"
              data-dismiss="modal"
              @click="$emit('closeModal')"
            >
              Cancel
            </button>
            <button
              class="sync-modal__save-lab btn btn-primary float-right"
              @click.prevent="$emit('sync', limit)"
              data-dismiss="modal"
            >
              Sync
            </button>
          </form>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginModal',
  props: {},
  data() {
    return {
      limit: 10000,
    }
  },
  methods: {
    // Get lab URL and open in new window
    // async saveLab() {
    //   const response = await api.saveLab(this.id, this.name, this.desc)
    //   if (response) {
    //     // TODO: success and close modal
    //     //$('.saved-labs__edit-lab-modal').modal('hide');
    //     this.$emit('lab-saved')
    //     this.$emit('closeModal')
    //   }
    // },
  },
  mounted() {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '~@/styles/globals';
</style>
